angular.module("vgresiduos").controller("ResidueMarketBackOfficeSuccessCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `mercado/back-office/sucesso`);
		};
	}
]);
